import { svg } from "lit";
const icon = svg `<path d="M2.8674 20.0965L8.59618 12.0965H13.627L20.3461 4.25237V20.0965H2.8674ZM3.76155 14.983L2.56543 14.1215L6.64428 8.40424H11.6847L16.2885 3.02539L17.4231 4.00807L12.3539 9.90422H7.39426L3.76155 14.983ZM5.79618 18.5965H18.8462V8.29649L14.2962 13.5965H9.34618L5.79618 18.5965Z" fill="currentColor"/>`;
export default icon;
